import { render } from "./MunicipiosTableView.vue?vue&type=template&id=4ec1ab70"
import script from "./MunicipiosTableView.vue?vue&type=script&lang=js"
export * from "./MunicipiosTableView.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/salvando-arvores-front/salvando-arvores-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__